// Using Resend via Vercel API routes
export interface EmailFormData {
  name: string;
  email: string;
  phone: string;
  services: string[];
  message: string;
}

export const sendEmail = async (formData: EmailFormData) => {
  try {
    // Use absolute URL in development, relative in production
    const baseUrl = import.meta.env.DEV ? 'http://localhost:3000' : '';
    const response = await fetch(`${baseUrl}/api/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    // Check if we got a valid response
    let responseData;
    try {
      responseData = await response.json();
    } catch (jsonError) {
      if (import.meta.env.DEV) {

        if (import.meta.env.DEV) {
          console.error('Failed to parse response as JSON:', jsonError);
        }

      }
      // If parsing fails, the API likely didn't return valid JSON.
      // Let the code proceed to the !response.ok check or throw a more specific error if needed.
      // We no longer simulate success in development here.
      throw new Error(`API response was not valid JSON. Status: ${response.status}. Error: ${jsonError}`);
    }
    
    if (!response.ok) {
      throw new Error(responseData?.error || 'Failed to send email');
    }
    
    return { success: true, response: responseData };
  } catch (error) {
    if (import.meta.env.DEV) {

      if (import.meta.env.DEV) {
        console.error('Email error:', error);
      }

    }
    return { 
      success: false, 
      error: error instanceof Error ? error.message : 'Unknown error' 
    };
  }
};
